import styled, { css } from "styled-components";
import { Title, ItemTitle } from "app-styled-components";
import { device } from "@core-const";
import { TitleH2, TitleH3, Label } from "app-styled/title";
import { FlexRow, FlexCol, FlexCenter } from "app-styled/flex";
import { LinkButtonSmall, LinkButtonXSmall } from "app-styled/link";

export const SigninFormContainer = styled(FlexCol)`
    ${({ theme }) => css`
    @media ${device.tablet} {
      padding: ${theme["thm-space-lg"]};
    }
  `}
`;


export const SigninWrapper = styled(FlexCol)`
  margin-top: 80px;
  align-items: center;
  ${({ theme }) => css`
    background-color: ${theme["thm-form"]};
    @media ${device.tablet} {
      margin-top: 147px;
    }
  `}
`;

export const RegisterContainer = styled(FlexRow)`
  overflow: hidden;
  ${({ theme }) => css`
    margin: ${theme["thm-space-xl"]};
    margin-top: 0px;
    background-color: ${theme["thm-light"]};
    border-radius: 10px;
    box-shadow: ${theme["smylor-pink"]} 0px 1px 2px 0px;
    @media ${device.tabletL} {
      flex-direction: column-reverse;
    }
    @media ${device.mobileL} {
      margin: ${theme["thm-space-lg"]};
    }
  `}
`;

export const SigninContainer = styled(FlexRow)`
  overflow: hidden;
  ${({ theme }) => css`
    margin: ${theme["thm-space-xl"]};
    margin-top: 0px;
    background-color: ${theme["thm-light"]};
    border-radius: 10px;
    box-shadow: ${theme["smylor-pink"]} 0px 1px 2px 0px;
    @media ${device.tabletL} {
      flex-direction: column-reverse;
    }
    @media ${device.mobileL} {
      width: calc(100% - 32px);
      margin: ${theme["thm-space-lg"]};
    }
  `}
`;

export const Welcome = styled(TitleH2)`
  ${({ theme }) => css`
    margin: ${theme["thm-space-xl"]};
    text-align: center;
    @media ${device.mobileL} {
      margin: ${theme["thm-space-lg"]};
  }
  `}
`;

export const SigninPageColumnBody = styled(FlexCol)`
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 600px;
  @media ${device.laptopL} {
    width: 500px;
  }

  @media ${device.tablet} {
    width: 400px;
  }

  @media ${device.mobileL} {
    width: 100%;
  }

  @media ${device.mobileS} {
    max-width: 300px;
  }
`;

export const SigninFormTitle = styled(TitleH3)`
  ${({ theme }) => css`
    color: ${theme["smylor-dark-blue"]};
    background-color: ${theme["header-blue"]};
    padding: ${theme["thm-space-lg"]} ${theme["thm-space-xl"]};

    @media ${device.tablet} {
      font-size: 28px;
      padding: 24px ${theme["thm-space-lg"]};
    }
  `}
`;

export const BackImageSignin = styled.div`
  width: 600px;
  height: auto;
  min-height: 500px;
  background-size: cover;

  ${({ theme, image }) => css`
    background-image: url("/assets/img/${image}.png");
  `}

  @media ${device.laptopL} {
    width: 500px;
  }

  @media ${device.laptop} {
    width: 400px;
    background-position-x: -50px;
  }

  @media ${device.tabletL} {
    display: none;
  }
`;

export const ButtonContainer = styled(FlexRow)`
  margin-left: auto;
  justify-content: flex-end;
  ${({ theme }) => css`
    @media ${device.tablet} {
    }

    @media ${device.mobileL} {
      margin-top: ${theme["thm-space-lg"]};
    }
  `}
  button{
    z-index: auto;
  }
`;

export const SigninFormBody = styled.div`
  ${({ theme }) => css`
    padding: ${theme["padding-container"]};
    @media ${device.tablet} {
      padding: 0;
    }
  `}
`;

export const RegisterFormInputContainer = styled.div`
  ${({ theme }) => css`
      padding: 0 ${theme["padding-container"]};
      .k-form-error {
        padding: 0 !important;
      }
    @media ${device.mobileL} {
        padding: 0 ${theme["thm-space-md"]};
    }
  `}
`;

export const InputWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    @media ${device.mobileS} {
    }
  `}
`;
export const LoadingWrapper = styled.div`
  ${({ theme }) => css`
      position: absolute;
      top: 26px;
      right: -10px;
      /* padding-right: ${theme["padding-container"]}; */
    @media ${device.mobileL} {
        /* padding: 0 ${theme["thm-space-md"]}; */
    }
  `}
`;

export const LoggedMessage = styled(Title)`
  display: flex;
  justify-content: center;
  ${({ theme }) => css`
    color: ${theme["color-backgroundDark"]};
  `}
`;

export const RegisterTitle = styled(ItemTitle)`
  ${({ theme }) => css`
  @media ${device.mobileS} {
       font-size: ${theme["thm-font-sm"]};
    }
  `}
`;

export const DentistLoginContainer = styled(FlexRow)`
  gap: 8px;
  align-items: baseline;
  ${({ theme }) => css`
    padding: 0px ${theme["thm-space-xl"]} ${theme["thm-space-md"]}
      ${theme["thm-space-xl"]};
    @media ${device.mobileL} {
      padding: ${theme["thm-space-md"]};
    }
    @media ${device.mobileS} {
      gap: 4px;
    }
  `}
`;

export const LoginHere = styled.a`
  cursor: pointer;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 600;
  ${({ theme }) => css`
    font-size: ${theme["thm-font-lg"]};
  `}
`;

export const RegitorFormDescription = styled.div`
  ${({ theme }) => css`
    font-style: italic;
    line-height: 18px;
    font-size: ${theme["thm-font-md"]};
    font-family: ${theme["fontFamily-regular"]};
    padding: 0px ${theme["thm-space-xl"]} ${theme["thm-space-lg"]} ${theme["thm-space-xl"]};
    margin-top: ${theme['thm-space-lg']};
    @media ${device.mobileL} {
      padding: ${theme["thm-space-md"]};
      margin-top: ${theme['thm-space-md']};
    }
  `};
`;

export const DentistAvailabilityDescription = styled.div`
  ${({ theme }) => css`
    font-style: italic;
    line-height: 18px;
    font-size: ${theme["thm-font-md"]};
    font-family: ${theme["fontFamily-regular"]};
    color: ${theme["smylor-pink"]};
    padding: 0px ${theme["thm-space-xl"]} ${theme["thm-space-lg"]} ${theme["thm-space-xl"]};
    @media ${device.mobileL} {
      padding: ${theme["thm-space-md"]};
    }
  `};
`;

export const LoginButton = styled(LinkButtonXSmall)`
  ${({ theme }) => css`
    border: 1px solid;
    background: inherit;
    @media ${device.mobileS} {
    margin: 0px;
  }
  `}
`;

export const FooterContainer = styled.div`
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  /* width: calc(100% - 80px); */
  @media ${device.tablet} {

    margin: 0rem 1rem;
  }
  @media ${device.mobileL} {
    margin: 0rem .75rem;
  };
`;

export const FormItemWrapper = styled.div`
  ${({ theme }) => css`
    margin: ${theme["thm-space-lg"]} 0;
      @media ${device.tablet} {
        padding: ${theme["thm-space-md"]} 0;
      };
  `};

  .checkboxCustomStyle {
    display: flex;
    flex-direction: row;
    font-size: 0.9rem;
    text-align: left;
    line-height: 1.2;
    letter-spacing: .1px;
    ${({ theme }) => css`
      font-family: ${theme["font-regular"]};
      gap: ${theme["thm-space-md"]};
    `};
  }
  .k-checkbox {
    ${({ theme }) => css`
      margin: ${theme["thm-space-sm"]};
    `};
  }
`;

export const PromoTextContainer = styled.div`
  ${({ theme }) => css`
    padding-bottom: ${theme["thm-space-md"]};
    @media ${device.mobileL} {
      margin: 0;
      padding: 0 ${theme["thm-space-md"]};
      padding-bottom: ${theme["thm-space-md"]};
    };
  `}
`;

export const CenterItemWrapper = styled(FlexCenter)`
  ${({ theme }) => css`
    padding: ${theme["thm-space-md"]} 0 0 0;
    margin-top: ${theme["thm-space-lg"]};
    @media ${device.mobileL} {
      padding: 0px;
    }
  `};
`;

export { LinkButtonSmall };
